import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'
import { FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'

const Contact = () => {
  const { t, i18n } = useTranslation()
  const isRTL = i18n.language === 'ar' || i18n.language === 'kr'

  const phones = [
    {
      city: t('contact.erbil'),
      number: '+964 750 005 3313',
      wa: '9647500053313',
    },
    {
      city: t('contact.sulaymani'),
      number: '+964 771 773 3113',
      wa: '9647717733113',
    },
    {
      city: t('contact.baghdad'),
      number: '+964 783 235 5551',
      wa: '9647832355551',
    },
  ]

  const email = 'dana.omer@snusconicotine.com'
  const address = 'Iraq - Erbil - Baxtyari'

  return (
    <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] mt-6 h-full mx-auto">
      <div className="w-[20%] md:w-[80%] sm:w-[90%] lg:w-[90%]">
        <h2 className="text-md font-bold p-2 rounded-tl-lg rounded-tr-lg bg-slate-200 text-slate-600">
          {t('contact.contact_us')}
        </h2>
      </div>

      <div className="border-t py-6 sm:w-full md:w-full mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
          {/* Phone numbers */}
          <div className="bg-white shadow-sm rounded-lg p-5">
            <div className="flex items-center gap-2 mb-4 text-slate-700">
              <FaPhone />
              <h3 className="font-bold text-lg">{t('contact.phones')}</h3>
            </div>
            <ul className="flex flex-col gap-3">
              {phones.map((p) => (
                <li
                  key={p.wa}
                  className="flex justify-between items-center border-b pb-2 last:border-b-0"
                >
                  <div className="text-slate-600">
                    <span className="font-medium">{p.city}: </span>
                    <a
                      href={`tel:${p.number.replace(/\s/g, '')}`}
                      className="hover:underline"
                      dir="ltr"
                    >
                      {p.number}
                    </a>
                  </div>

                  <a
                    href={`https://wa.me/${p.wa}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-600 hover:text-green-800"
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp size={22} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Email + Address */}
          <div className="bg-white shadow-sm rounded-lg p-5 flex flex-col gap-5">
            <div>
              <div className="flex items-center gap-2 mb-2 text-slate-700">
                <FaEnvelope />
                <h3 className="font-bold text-lg">{t('contact.email')}</h3>
              </div>
              <a
                href={`mailto:${email}`}
                className="text-slate-600 hover:underline break-all"
                dir="ltr"
              >
                {email}
              </a>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-2 text-slate-700">
                <FaMapMarkerAlt />
                <h3 className="font-bold text-lg">{t('contact.address')}</h3>
              </div>
              <p className="text-slate-600">{address}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
